import React, { useEffect } from 'react';
import apiConfig from '@constants/apiConfig';
import useFetch from '@hooks/useFetch';
import useSaveBase from '@hooks/useSaveBase';

import KitplaySettingForm from './KitplaySettingForm';

const KitplaySettingSavePage = ({ deviceId }) => {
    const { execute } = useFetch(apiConfig.kitplayDevice.getById, {
        immediate: false,
    });

    const { detail, mixinFuncs, loading, loadingSubmit, isChanged, setIsChangedFormValues, isEditing, setEditing } = useSaveBase({
        apiConfig: {
            ...apiConfig.kitplayDevice,
            update: apiConfig.kitplayDevice.updateSettings,
        },
        override: (funcs) => {
            funcs.getDetail = () => {
                execute({
                    pathParams: { id: deviceId },
                    onCompleted: (response) => {
                        funcs.setDetail(funcs.mappingData(response));
                    },
                    onError: funcs.handleGetDetailError,
                });
            };
            funcs.prepareUpdateData = (data) => {
                return {
                    ...data,
                    id: deviceId,
                };
            };
            funcs.onBack = () => {
                setIsChangedFormValues(false);
                funcs.getDetail();
            };
        },
    });

    useEffect(() => {
        if (deviceId) {
            setEditing(true);
            mixinFuncs.getDetail();
        }
    }, [deviceId]);

    return (
        <KitplaySettingForm
            setIsChangedFormValues={setIsChangedFormValues}
            dataDetail={detail ? detail : {}}
            formId={mixinFuncs.getFormId()}
            isEditing={isEditing}
            actions={mixinFuncs.renderActions()}
            loading={loading || loadingSubmit}
            isChanged={isChanged}
            onSubmit={mixinFuncs.onSave}
        />
    );
};

export default KitplaySettingSavePage;
